import type { PositiveNumberMessages } from "web_myplann/Shared/Validation/Types/PositiveNumberMessages";
import { type ZodType, z } from "zod";

export const optionalPositiveInteger = (
	max: number,
	messages: PositiveNumberMessages,
): ZodType<number | null, z.ZodTypeDef, number | null | undefined> =>
	z
		.number()
		.int(messages.positiveMessage)
		.min(1, messages.positiveMessage)
		.max(max, messages.maxMessage)
		.nullish()
		.transform((val) => val ?? null);
